export default {
  id: 111,
  title: 'Target #111 - Rain Drops',
  url: 'https://cssbattle.dev/play/111',
  colors: ['#F3AC3C', '#254241'],
  solution:
    '<a a><a b><style>[a],[b]{background:#254241}body{background:#f3ac3c}a{position:fixed}[a]{top:110;left:80;width:80;height:80;border-radius:9in;box-shadow:80px -70px #254241,80px 70px #254241}[b]{top:130;left:128;width:40;height:40;box-shadow:7px -66px #254241,66px -7px #254241;transform:rotate(45deg)}</style>',
}
